import React, { Component } from 'react';

import IndexMain from '../../components/IndexMain/IndexMain';
import paths from '../../constants/paths';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { nbsApiAppleAuth } from '../../store/actions/appleAuth';
import { storeAppleData } from '../../store/actions/appleData';
import { setSessionToken } from '../../store/actions/session';
import strings from '../../assets/localization';
import { resetAccountStatus } from '../../store/actions/resetAccountStatus';
import { getRomanceGuardParam, isEmpty } from '../../assets/helpers/utils';
import URLSearchParams from 'url-search-params';
import { setUserCreateAccountData } from '../../store/actions/createAccountData';

class IndexPage extends Component {
  state = {
    showAlert: false,
    errorMessage: null,
    accountStatus: false,
    showLogout: false,
    showReactivateModal: false,
    isReactivateApple: false,
    mailIsConfirmed: false,
    queryString: '',
    showSpinner: false,
    isOneClick: false,
  };

  loginTokenAuthData = null;

  UNSAFE_componentWillMount() {
    const query = new URLSearchParams(this.props.location.search);
    const restorePasswordToken = query.get('restore_password_token');

    if (restorePasswordToken) {
      // redirect to new password route
      query.delete('restore_password_token');
      // make it in form '/route/token/?query=...'
      this.props.history.replace({
        pathname: paths.NEW_PASSWORD + '/' + restorePasswordToken + '/',
        search: query.toString(),
      });
    } else if (query.get('contact_us')) {
      // redirect to contact-us route
      query.delete('contact_us');
      this.props.history.replace({
        pathname: paths.CONTACT_US,
        search: query.toString(),
      });
    } else if (query.toString()) {
      this.setState({ queryString: query.toString() });
    }
    if (this.props.location.search.includes('code')) {
      let ref = document.referrer;
      // if not from apple redirect to index
      if (ref.match(/appleid|apple\.com/) === null) {
        this.props.history.push(paths.INDEX);
      } else {
        // if from apple then login
        const code = query.get('code').toString().trim();
        this.props.storeAppleData(code);
        this.loginWithApple(code);
      }
    }

    if (query.get('oneclick')) {
      this.setState({ isOneClick: true });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.appleAuth.status === 'success' &&
      nextProps.appleAuth.status !== this.props.appleAuth.status
    ) {
      this.props.setSessionToken(nextProps.appleAuth.response.token);
    } else if (
      nextProps.appleAuth.status === 'fail' &&
      nextProps.appleAuth.status !== this.props.appleAuth.status
    ) {
      if (nextProps.appleAuth.error.error_code === 3) {
        this.setState({ showReactivateModal: true, isReactivateApple: true });
      } else {
        this.toggleAlertError(nextProps.appleAuth.error.error);
      }
    }

    if (
      nextProps.checkAccountStatus.logOut &&
      this.state.showLogout === false
    ) {
      // display logout page
      this.setState({ showLogout: !this.state.showLogout });
      this.props.resetAccountStatus();
    }
    if (
      nextProps.checkAccountStatus.deactivate &&
      this.state.showAlert === false
    ) {
      this.setState({ accountStatus: !this.state.accountStatus });
      this.toggleAlertError(strings.accountSuccDeact);
    }
    if (nextProps.checkAccountStatus.delete && this.state.showAlert === false) {
      this.setState({ accountStatus: !this.state.accountStatus });
      this.props.history.push(paths.INDEX);
      window.scrollTo(0, 0);
      this.toggleAlertError(strings.accountSuccDelete);
    }
  }

  gotoLogin = () => {
    this.props.history.push({
      pathname: paths.LOGIN,
      search: this.state.queryString,
    });
  };

  goBack = () => {
    this.setState({ showReactivateModal: !this.state.showReactivateModal });
  };

  goToCreateAccount = (step = 1) => {
    if (typeof step === 'number') {
      this.props.setUserCreateAccountData({ step });
    }
    this.props.history.push({
      pathname: paths.SIGNUP,
      search: this.state.queryString,
    });
  };

  toggleAlertError = (errorMessage) => {
    this.setState({ showAlert: !this.state.showAlert, errorMessage });
    if (this.state.accountStatus) {
      this.props.resetAccountStatus();
    }
  };

  loginWithApple = (data, activate = null) => {
    const obj = {
      login_type: 'apple',
      signup_type: 'apple',
      code: !isEmpty(this.props.appleData) ? this.props.appleData : data,
      device_type: 3,
      platform: 'web',
      __RG: getRomanceGuardParam(),
      activate,
    };
    this.props.nbsApiAppleAuth(obj);
  };

  render() {
    return (
      <IndexMain
        setUserCreateAccountData={this.props.setUserCreateAccountData}
        getConfig={this.props.getConfig}
        showSpinner={this.state.showSpinner}
        history={this.props.history}
        showReactivateModal={this.state.showReactivateModal}
        isReactivateApple={this.state.isReactivateApple}
        loginWithApple={this.loginWithApple}
        appleData={this.props.appleData}
        gotoLogin={this.gotoLogin}
        goBack={this.goBack}
        errorAlertMessage={this.state.errorMessage}
        showErrorAlert={this.state.showAlert}
        dismissAlert={this.toggleAlertError}
        accountStatus={this.state.accountStatus}
        goToCreateAccount={this.goToCreateAccount}
        isLandscape={this.props.isLandscape}
        isOneClick={this.state.isOneClick}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    appleData: state.appleData.appleLoginData,
    appleAuth: state.appleAuth,
    checkAccountStatus: state.checkAccountStatus,
    getConfig: state.getConfig,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      nbsApiAppleAuth,
      storeAppleData,
      setSessionToken,
      resetAccountStatus,
      setUserCreateAccountData,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(IndexPage);



// WEBPACK FOOTER //
// ./src/containers/IndexPage/IndexPage.js